/** @format */

import Moment from 'moment';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';
import React, { useState, useEffect, forwardRef } from 'react';

import 'moment/locale/nb';
import 'react-datepicker/dist/react-datepicker.css';

function DatePickerTravel() {
	const [t] = useTranslation('translation');
	const userlanguage = useStoreState((state) => state.user.language);
	Moment.locale(userlanguage);

	const data = useStoreState((state) => state.travelSearch);
	const dateValue = useStoreState((state) => data.departureDate);
	const setTravelSearchDate = useStoreActions((actions) => actions.travelSearch.setDepartureDate);
	const setTravelOut = useStoreActions((actions) => actions.cart.setTravelOut);
	const today = Moment().startOf('day');

	const yesterday = Moment().add(-1, 'days');
	const selectedDate = Moment(new Date(dateValue));

	let dateDiff = Moment(today).diff(selectedDate, 'days');

	let startCounter = dateDiff === 0 ? 0 : -2;
	let endCounter = dateDiff >= 0 ? 5 : 3;

	let dayList = [];

	const resetTravel = () => setTravelOut(null);

	useEffect(() => {
		if (dateValue === null) {
			setTravelSearchDate(today);
		}
	}, [dateValue, setTravelSearchDate, today]);

	const handleOnClick = async (item) => {
		var date = Moment(item);
		var today = new Date();
		today.setHours(0);
		today.setMinutes(0);
		today.setSeconds(0);
		today.setMilliseconds(0);

		if (date >= today) {
			if (date != null) {
				setTravelSearchDate(date);
				resetTravel();
			}
		}
	};

	const [isOpen, setIsOpen] = useState(false);
	const CalendarCustomInput = forwardRef(({ onClick }, ref) => (
		<button className='react-datepicker-button' onClick={onClick} ref={ref}>
			<svg xmlns='http://www.w3.org/2000/svg' width='35' height='37' viewBox='0 0 35 37'>
				<path
					fill='#{url-friendly-colour($dark)}'
					fillRule='nonzero'
					d='M34.1 8.1v25.7c0 1.4-1.2 2.6-2.6 2.6H3.2c-1.4 0-2.6-1.2-2.6-2.6V8.1c0-1.4 1.2-2.6 2.6-2.6h2.6V3.6C5.8 1.8 7.2.4 9 .4h1.3c1.8 0 3.2 1.4 3.2 3.2v1.9h7.7V3.6c0-1.8 1.4-3.2 3.2-3.2h1.3c1.8 0 3.2 1.4 3.2 3.2v1.9h2.6c1.4 0 2.6 1.2 2.6 2.6zm-7.8 1.2V3.5c0-.3-.3-.6-.6-.6h-1.3c-.3 0-.6.3-.6.6v5.8c0 .3.3.6.6.6h1.3c.3.1.6-.2.6-.6zm-.6 9.7h5.8v-5.8h-5.8V19zM18 19h6.4v-5.8H18V19zm7.7 7.7h5.8v-6.4h-5.8v6.4zM10.9 9.3V3.5c0-.3-.3-.6-.6-.6H9c-.3 0-.6.3-.6.6v5.8c0 .3.3.6.6.6h1.3c.3.1.6-.2.6-.6zM18 26.7h6.4v-6.4H18v6.4zm7.7 7.1h5.8V28h-5.8v5.8zM10.3 19h6.4v-5.8h-6.4V19zM18 33.8h6.4V28H18v5.8zM3.2 19H9v-5.8H3.2V19zm7.1 7.7h6.4v-6.4h-6.4v6.4zm-7.1 0H9v-6.4H3.2v6.4zm7.1 7.1h6.4V28h-6.4v5.8zm-7.1 0H9V28H3.2v5.8z'
				/>
			</svg>
		</button>
	));

	for (
		let m = Moment(selectedDate).add(startCounter, 'days');
		m.isBefore(Moment(selectedDate).add(endCounter, 'days'));
		m.add(1, 'days')
	) {
		dayList.push(Moment(new Date(m)));
	}

	return (
		<>
			<div className='with-label'>
				<label>{t('travelDate')}</label>
				<div className='daypicker'>
					{dayList.map((item, i) => {
						return (
							<button
								onClick={
									item.isAfter(yesterday)
										? () => handleOnClick(item)
										: () => alert('Dato ikke tilgjengelig')
								}
								className={
									selectedDate.isSame(item)
										? 'day-button selected'
										: item.isAfter(yesterday)
										? 'day-button'
										: 'day-button disabled'
								}
								key={i}
							>
								<label>{item.format('ddd')}</label>
								<h1>{item.format('DD')}</h1>
								<div>{item.format('MMMM')}</div>
							</button>
						);
					})}

					<div style={{ zIndex: 10 }}>
						<DatePicker
							open={isOpen}
							selected={new Date(dateValue)}
							onChange={(date) => handleOnClick(date)}
							onCalendarOpen={() => setIsOpen(true)}
							onCalendarClose={() => setIsOpen(false)}
							customInput={<CalendarCustomInput />}
							calendarStartDay={1}
						/>
					</div>
				</div>
			</div>
			{isOpen && <div className='react-datepicker-backdrop'></div>}
		</>
	);
}

export default DatePickerTravel;
